import React, { useRef } from 'react';
import { FastField } from 'formik';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './FormFile.module.scss';
const cx = classNames.bind(styles);
import FormFeedback from '../FormFeedback';
import { formLabel } from '~/utils/helpers';
import { isEmpty } from 'lodash';

const FormFile = React.forwardRef(function FormFile({ className, name, sm, onChangePicture, inline, as }, ref) {
    const id = name + '-formControl';
    const _ref = useRef(null);
    const inputRef = !isEmpty(ref) ? ref : _ref;

    return (
        <FastField name={name}>
            {({ field, form, meta }) => {
                const isValid = !meta.error;
                const isInvalid = meta.touched && !isValid;

                return (
                    <Form.Group
                        as={as}
                        className={cx(['cursor-pointer', className])}
                        sm={sm}
                    >
                        <p className={cx({ 'col-sm-3 col-form-label': inline })}>{formLabel(name)}</p>
                        {/* custom file input. Ref: https://stackoverflow.com/a/39827731/11297747 */}
                        <div className={cx('wrapper', { 'col-sm-9': inline })}>
                            <label
                                htmlFor={id}
                                className={cx(['file-label', 'ml-2', 'cursor-pointer'])}
                            >
                                {'Browse Computer...'}
                            </label>
                            <input
                                type="file"
                                placeholder="Browse computer"
                                id={id} //add "-formControl" suffix to differentiate with id in Icon component.
                                name={name}
                                //accept=".png,.jpg,.jpeg" //it's possible to pass native event (like onChange, onBlur) here, even though the doc not mentioned
                                accept="image/*"
                                onChange={(e) => {
                                    const fileObj = e.target.files[0];
                                    form.setFieldValue(field.name, fileObj); // (1)  //this is for formik setting value
                                    onChangePicture(fileObj); //this is for picture preview
                                }}
                                onBlur={() => {
                                    form.setFieldTouched(field.name);
                                }}
                                ref={inputRef}
                            />
                            <span
                                className={cx('select-file')}
                                onClick={() => {
                                    if (inputRef) {
                                        inputRef.current.click();
                                    } else {
                                        document.getElementById(id).click();
                                    }
                                }}
                                tabIndex="0"
                            >
                                Select File
                            </span>
                        </div>
                        <FormFeedback
                            isInvalid={isInvalid}
                            errorMessage={meta.error}
                            className={inline ? 'offset-sm-3' : ''}
                        />
                    </Form.Group>
                );
            }}
        </FastField>
    );
});

FormFile.defaultProps = {
    className: '',
    sm: 2,
    inline: false,
    as: Col,
};
FormFile.propTypes = {
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChangePicture: PropTypes.func.isRequired,
    inline: PropTypes.bool,
    as: PropTypes.elementType,
};
export default FormFile;

/**Note */
//(1)need to explicitly set value here for validation to be triggered. Ref: https://github.com/jaredpalmer/formik/issues/926#issuecomment-1197970034
//(2) onChange will not trigger `touched` (which is needed to set if the field is invalid), so we need to use handleBlur().
//Ref: https://formik.org/docs/guides/validation#when-does-validation-run ("things that update touched"),
//https://github.com/jaredpalmer/formik/issues/114#issuecomment-323134473 ("We don't want a change event to mark the field as touched")
//https://stackoverflow.com/questions/57385931/why-isnt-the-formik-touched-property-being-populated (first 2 answers)
